import { CancelDigitalSignRequest, CancelDigitalSignResponse } from "@/services/common/types";

export function useCancelDigitalSign() {
  const cancelDigitalSign = async (request: CancelDigitalSignRequest) => {
    const result = await fetch(`/api/registration/cancel-digital-sign`, {
      body: JSON.stringify(request),
      method: "POST",
    });
    const { data } = await result.json();
    const resultJson = data as CancelDigitalSignResponse;
    return resultJson;
  }
  return { cancelDigitalSign };
}